import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { NgxLoggerSessionIdService } from '@allianz/ngx-logger';
import { Observable } from 'rxjs';
import { skipSessionIdHeader } from 'shared-utils';

@Injectable()
export class CustomLoggerInterceptor implements HttpInterceptor {
  private readonly ngxLoggerSessionIdService = inject(NgxLoggerSessionIdService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldSkip: boolean = req.headers.has(skipSessionIdHeader);

    if (shouldSkip) {
      const cleanHeaders: HttpHeaders = req.headers.delete(skipSessionIdHeader);
      const cleanReq: HttpRequest<unknown> = req.clone({ headers: cleanHeaders });

      return next.handle(cleanReq);
    }

    const reqClone: HttpRequest<unknown> = req.clone({
      setHeaders: {
        'session-id': this.ngxLoggerSessionIdService.getOrCreateSessionId(),
      },
    });

    return next.handle(reqClone);
  }
}
